import { render } from "./PikleSuggestionCard.vue?vue&type=template&id=8a34d018&scoped=true"
import script from "./PikleSuggestionCard.vue?vue&type=script&lang=js"
export * from "./PikleSuggestionCard.vue?vue&type=script&lang=js"

import "./PikleSuggestionCard.vue?vue&type=style&index=0&id=8a34d018&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a34d018"]])

export default __exports__